module.exports = __webpack_public_path__ + "media/home.eb58974a.mp4";